import classNames from 'classnames'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import InputFullTime from 'components/InputFullTime'
import Checkbox from 'components/Checkbox'
import CustomErrorMessage from 'components/CustomErrorMessage'
import { DAYS_OF_THE_WEEK } from 'resources'
import { isEmpty } from 'lodash'

const DayOpeningHours = ({
  dayName,
  activeDay,
  startTime,
  endTime,
  type,
  handleChange,
  showValidationErrors,
  setValidationErrorsHours,
  validationErrorsHours,
}) => {
  const [openHours, setOpenHours] = useState()
  const [closeHours, setCloseHours] = useState()
  const [active, setActive] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const isEmptyMinutsOrHours =
    isEmpty(openHours?.hour) ||
    isEmpty(openHours?.minute) ||
    isEmpty(closeHours?.hour) ||
    isEmpty(closeHours?.minute)

  const handleChangeTimeOpenHours = (value) => {
    setOpenHours(value)
  }
  const handleChangeTimeCloseHours = (value) => {
    setCloseHours(value)
  }

  const onChangeCheckBox = (e) => {
    setActive(!active)
    setOpenHours('')
    setCloseHours('')
  }

  useEffect(() => {
    handleChange({
      dayName,
      startTime: openHours?.fullTime,
      endTime: closeHours?.fullTime,
      disabled: !active,
      type,
    })
  }, [openHours?.fullTime, closeHours?.fullTime, active])

  useEffect(() => {
    setActive(!activeDay)
  }, [activeDay])

  useEffect(() => {
    if (!active) {
      setIsError(false)
    } else if (active === true && isEmptyMinutsOrHours) {
      setIsError(true)
      setErrorMessage('Invalid time format')
    } else if (
      openHours?.fullTime !== '00:00' &&
      openHours?.hour > closeHours?.hour
    ) {
      setIsError(true)
      setErrorMessage('End time can not be earlier than start time')
    } else if (
      openHours?.hour === closeHours?.hour &&
      openHours?.minute > closeHours?.minute
    ) {
      setIsError(true)
      setErrorMessage('End time can not be earlier than start time')
    } else {
      setIsError(false)
    }
  }, [
    openHours?.fullTime,
    openHours?.hour,
    closeHours?.hour,
    openHours?.minute,
    closeHours?.minute,
    active,
  ])

  useEffect(() => {
    if (isError) {
      setValidationErrorsHours({
        ...validationErrorsHours,
        [dayName]: true,
      })
    } else {
      setValidationErrorsHours({
        ...validationErrorsHours,
        [dayName]: false,
      })
    }
  }, [isError])

  return (
    <>
      <div className="day-opening-hours">
        <Checkbox onChange={onChangeCheckBox} checked={active} />
        <p
          className={classNames('day-opening-hours__day-name', {
            '-active-day': active,
          })}
        >
          {DAYS_OF_THE_WEEK[dayName]}
        </p>
        <div className="day-opening-hours__wrapper">
          <div className="day-opening-hours__open-hours">
            <InputFullTime
              time={startTime}
              isShorter={true}
              handleChange={handleChangeTimeOpenHours}
              isActive={active}
            />
          </div>
          <span className="day-opening-hours__connector">to</span>
          <div className="day-opening-hours__close-hours">
            <InputFullTime
              time={endTime}
              isShorter={true}
              handleChange={handleChangeTimeCloseHours}
              isActive={active}
            />
          </div>
        </div>
      </div>
      {isError && showValidationErrors && (
        <CustomErrorMessage info={errorMessage} />
      )}
    </>
  )
}

DayOpeningHours.defaultProps = {
  activeDay: false,
}

DayOpeningHours.propTypes = {
  dayName: PropTypes.string.isRequired,
  activeDay: PropTypes.bool.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}

export default DayOpeningHours
